"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RapsaParser = exports.ParamErrorType = exports.ErrorType = exports.PURCHASE_EXPIRE_DATE = exports.BORNA_TRANSACTION_ID = exports.WALLET_TOKEN = exports.AMOUNT = exports.PURCHASE = exports.TRANSFER = exports.RAPSA = void 0;
const base62_1 = require("../base62");
const luhnCheck_1 = require("./luhnCheck");
exports.RAPSA = "rapsa:";
// paths
exports.TRANSFER = "t";
exports.PURCHASE = "p";
// parameters
exports.AMOUNT = "a";
exports.WALLET_TOKEN = "w";
exports.BORNA_TRANSACTION_ID = "b";
exports.PURCHASE_EXPIRE_DATE = "ts";
var ErrorType;
(function (ErrorType) {
    ErrorType[ErrorType["INVALID_PROTOCOL"] = 1] = "INVALID_PROTOCOL";
    ErrorType[ErrorType["INVALID_PATH"] = 2] = "INVALID_PATH";
    ErrorType[ErrorType["NO_VALID_PARAM"] = 3] = "NO_VALID_PARAM";
    ErrorType[ErrorType["PURCHASE_DATE_HAS_EXPIRED"] = 4] = "PURCHASE_DATE_HAS_EXPIRED";
})(ErrorType || (exports.ErrorType = ErrorType = {}));
var ParamErrorType;
(function (ParamErrorType) {
    ParamErrorType[ParamErrorType["LUHN_CHECK"] = 1] = "LUHN_CHECK";
    ParamErrorType[ParamErrorType["INVALID_BASE_62"] = 2] = "INVALID_BASE_62";
})(ParamErrorType || (exports.ParamErrorType = ParamErrorType = {}));
class RapsaParser {
    getParam(paramType, paramList, searchParams) {
        const paramBase62 = searchParams.get(paramType);
        if (paramBase62 == null)
            return paramList;
        const value = (0, base62_1.base62ToBase10)(paramBase62);
        const isValid = (0, base62_1.isValidBase62String)(paramBase62);
        return Object.assign(Object.assign({}, paramList), { [paramType]: {
                value,
                isValid: isValid,
                error: !isValid ? ParamErrorType.INVALID_BASE_62 : undefined,
            } });
    }
    getWalletTokenParam(paramList, searchParams) {
        const allParams = searchParams.getAll(exports.WALLET_TOKEN);
        if (allParams.length == 0)
            return paramList;
        const params = allParams.map((p) => {
            const value = (0, base62_1.base62ToBase10)(p);
            const isValid = (0, base62_1.isValidBase62String)(p);
            const passedLuhmCheck = (0, luhnCheck_1.luhnCheck)(`${value}`);
            const errorType = isValid
                ? passedLuhmCheck
                    ? undefined
                    : ParamErrorType.LUHN_CHECK
                : ParamErrorType.INVALID_BASE_62;
            return {
                value,
                isValid: isValid && passedLuhmCheck,
                error: errorType,
            };
        });
        return Object.assign(Object.assign({}, paramList), { [exports.WALLET_TOKEN]: params });
    }
    getParamListError(paramList) {
        var _a;
        if ((_a = paramList.ts) === null || _a === void 0 ? void 0 : _a.isValid) {
            const expireDate = Number(paramList === null || paramList === void 0 ? void 0 : paramList.ts.value) * 1000;
            if (expireDate < Date.now())
                return ErrorType.PURCHASE_DATE_HAS_EXPIRED;
        }
        return Object.values(paramList)
            .reduce((acc, param) => Array.isArray(param) ? [...acc, ...param] : [...acc, param], [])
            .reduce((acc, param) => acc || param.isValid, Object.keys(paramList).length == 0)
            ? undefined
            : ErrorType.NO_VALID_PARAM;
    }
    parse(url) {
        try {
            const parsedUrl = new URL(url);
            if (parsedUrl.protocol != exports.RAPSA) {
                return {
                    error: ErrorType.INVALID_PROTOCOL,
                };
            }
            if (![exports.TRANSFER, exports.PURCHASE].includes(parsedUrl.hostname)) {
                return {
                    error: ErrorType.INVALID_PATH,
                };
            }
            const action = parsedUrl.hostname;
            const searchParams = parsedUrl.searchParams;
            let paramList = {};
            paramList = this.getParam(exports.AMOUNT, paramList, searchParams);
            paramList = this.getWalletTokenParam(paramList, searchParams);
            paramList = this.getParam(exports.BORNA_TRANSACTION_ID, paramList, searchParams);
            paramList = this.getParam(exports.PURCHASE_EXPIRE_DATE, paramList, searchParams);
            const error = this.getParamListError(paramList);
            return Object.assign(Object.assign({}, paramList), { action,
                error });
        }
        catch (error) {
            return {
                error: ErrorType.INVALID_PROTOCOL,
            };
        }
    }
}
exports.RapsaParser = RapsaParser;
//# sourceMappingURL=rapsaParser.js.map